import { useRef } from 'react';
import Overlay from 'react-bootstrap/Overlay';
import { useTranslation } from 'react-i18next';
import KizenTypography from 'app/kizentypo';
import TextInput from 'components/Inputs/TextInput';
import { ErrorCard } from '../../styles';

const FormNameInput = ({ value, errorMessage, ...rest }) => {
  const { t } = useTranslation();
  const ref = useRef();
  const showError = errorMessage.length > 0;

  return (
    <>
      <TextInput
        ref={ref}
        value={value}
        label={t('Name')}
        placeholder={t('Enter Name')}
        error={value?.length === 0}
        {...rest}
      />
      <Overlay
        transition={!showError}
        target={ref.current}
        show={showError}
        placement="bottom-start"
      >
        <ErrorCard show={showError} data-qa="form-name-error-message">
          <KizenTypography>{errorMessage}</KizenTypography>
        </ErrorCard>
      </Overlay>
    </>
  );
};

export default FormNameInput;
